import angular from "angular";
import {drawViewModule} from './draw-view';
import {designViewModule} from './design-view';
import {summaryViewModule} from './summary-view';
import {startViewModule} from "./start-view";

export default angular.module('slViz.views', [
    startViewModule,
    drawViewModule,
    designViewModule,
    summaryViewModule
]).name;



// WEBPACK FOOTER //
// ./src/js/views/index.js